import { useQuery } from '@tanstack/react-query';
import { useTranslation } from '@hooks';
import { SharedServices } from '@services';
import { ProductSlider } from '@components/ui';
import { ShineIcon } from '@components/icons';

const TrendOfWeeks = () => {
    const { t } = useTranslation();
    const { data, isLoading } = useQuery({
        queryKey: ['getTrendOfWeeks'],
        queryFn: SharedServices.getTrendOfWeeks,
    });
    return (
        !isLoading && (
            <ProductSlider
                products={data?.data}
                title={t('trendsofWeek')}
                isLoading={isLoading}
                icon={<ShineIcon width={16} />}
            />
        )
    );
};

export default TrendOfWeeks;
